module.exports = __webpack_public_path__ + "images/ab0a982a3efc03fa0462634d39a1df63.png";